<template>
  <div class="home">
    <toolbar-user></toolbar-user>
    <v-container>
        <v-row justify="space-around">
      <v-col cols="12" md="6" lg="6" xs="12">
        <div class="text-center mt-10">
            <img src="../assets/img1.jpeg" class="images animate__animated animate__heartBeat">
          
        </div>
      </v-col>

      <v-col cols="12" md="6" lg="6" xs="12">
        <div class="text-center">
       
   
    <v-card class=" card w-100"  elevation="20" >
    

    <v-card-text >
      <div class="font-weight-bold ms-1 mb-2 "> RESIN ARTS نبذة عن موقعنا  </div>

      <v-timeline  density="compact" side="start">
        <v-timeline-item
         
          v-for="message in messages"
          :key="message"
          :dot-color="message.color"
          size="x-small"
        >
          <div class="mb-4">
            <div class="font-weight-normal">
              <strong>{{ message.from }}</strong>
            </div>

            <div>{{ message.message }}</div>
            <h4 v-if="message.color=='green'"> +1 (438)-877-4430 </h4>
          </div>
         
        </v-timeline-item>
        
      </v-timeline>
    </v-card-text>
      <v-btn
      class="enterbtn mb-2"
       
        append-icon="mdi-chevron-right"
        color="white"
        href="login"
        text="أدخل الأن"
        variant="outlined"
        block
      ></v-btn>
    <v-img
      color="surface-variant"
      height="200"
      :src="imageCard"
      cover
    >
   </v-img>
  </v-card>

      
        </div>
      </v-col>
        </v-row>
   
  
    </v-container>
  </div>
</template>
<style scoped>
.images{
  width:300px;
  height: 300px;
}
.card{

  text-align: right;
  padding: 20px !important;
  border-radius: 10px 10px 10px 10px !important;

 

}
.item{
  margin: right !important;
}
.enterbtn{
  background-color: rgb(145, 85, 145) !important;
}
</style>
<script>

import ToolbarUser from '../components/ToolbarUsers.vue'

export default {
  components:{
ToolbarUser
  },

data: () => ({
      messages: [
        {
          from: 'محتوي فني تعليمي',
          message: `موقعنا يقدم شرح مفصل بإستخدام الريزن لعمل مشاريع مختلفه `,
          color: 'deep-purple-lighten-1',
        },
        {
          from: ' للحجز و الاستعلام ',
          message: ' تواصل علي الرقم اسفل الصفحه للحصول علي اسم مستخدم وكلمة السر الخاصة بك أو عن طريق الواتس اب علي رقم ',
          color: 'green',
        }, {
          from: 'لديك حساب بالفعل ',
          message: ' اذا كان لديك اسم مستخدم و كلمه مرور  بالفعل اضفط علي الزر التالي لتشاهد المحتوي بالكامل',
         
          color: 'deep-purple-lighten-1',
        },
      ],

    }),
    computed:{
      imageCard() {
        return require('../assets/img2.jpg')
      }
    }
  }

</script>
